<template>
  <v-container>
    <v-overlay :value="state === 'edit' && fieldStatus === true" :opacity="0.2" color="white">
      <v-card color="primary" dark width="250">
        <v-card-text class="pt-1">
          <div class="py-2 text-center">{{ $t("PANEL.USER.DETAIL.LOADING_DETAIL") }}</div>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-overlay>
    <v-row>
      <v-col cols="12" md="3">
        <UserNavigation />
      </v-col>
      <v-col cols="12" md="9">
        <v-toolbar dense dark color="#555" rounded>
          <v-toolbar-title class="text-body-1" v-if="state === 'new'">
            <v-icon left>mdi-account-plus</v-icon>
            {{ $t("PANEL.USER.DETAIL.ADD_NEW_USER") }}
          </v-toolbar-title>
          <v-toolbar-title class="text-body-1" v-else>
            <v-icon left>mdi-account-edit</v-icon>
            {{ $t("PANEL.USER.DETAIL.UPDATE_USER") }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card class="px-2">
          <v-container>
            <v-row>
              <v-col cols="12" class="px-0 py-0">
                <v-row class="mx-0">
                  <v-col cols="12" lg="7">
                    <v-text-field
                      prepend-icon="mdi-account"
                      :label="$t('PANEL.USER.DETAIL.NAME_LABEL')"
                      :hint="$t('PANEL.USER.DETAIL.NAME_HINT')"
                      persistent-hint
                      class="mt-0"
                      v-model="userData.name"
                      :loading="fieldStatus"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="7">
                    <v-text-field
                      prepend-icon="mdi-account-star"
                      :label="$t('PANEL.USER.DETAIL.NICK_LABEL')"
                      :hint="$t('PANEL.USER.DETAIL.NICK_HINT')"
                      persistent-hint
                      class="mt-0"
                      v-model="userData.nickname"
                      :loading="fieldStatus"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="7">
                    <v-text-field
                      prepend-icon="mdi-email"
                      :label="$t('PANEL.USER.DETAIL.EMAIL_LABEL')"
                      :hint="$t('PANEL.USER.DETAIL.EMAIL_HINT')"
                      persistent-hint
                      class="mt-0"
                      v-model="userData.email"
                      :loading="fieldStatus"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="7">
                    <v-select
                      prepend-icon="mdi-account-group"
                      :items="userGroups"
                      item-text="name"
                      item-value="sysname"
                      :label="$t('PANEL.USER.DETAIL.GROUP_LABEL')"
                      :hint="$t('PANEL.USER.DETAIL.GROUP_HINT')"
                      persistent-hint
                      v-model="userData.group"
                      :loading="fieldStatus"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="userFields.length > 0">
                <v-row class="mx-0">
                  <v-col cols="12" lg="7">
                    <v-alert icon="mdi-arrow-down-thick" color="grey lighten-3" elevation="1" class="text-body-2 pb-2 pt-3 mb-0"
                      >{{ $t("PANEL.USER.DETAIL.ADDITIONAL_TITLE") }}
                    </v-alert>
                  </v-col>
                  <v-col cols="12" lg="7">
                    <div :key="key" v-for="(field, key) in userFields">
                      <v-text-field
                        v-if="userFieldUtils[field].type === 'text'"
                        filled
                        dense
                        prepend-icon="mdi-focus-field-horizontal"
                        :label="userFieldUtils[field].text"
                        v-model="fields[key]"
                        persistent-hint
                      ></v-text-field>
                      <v-file-input
                        v-else-if="userFieldUtils[field].type === 'file'"
                        filled
                        :label="userFieldUtils[field].text"
                        v-model="fields[key]"
                        truncate-length="15"
                      ></v-file-input>
                      <v-textarea
                        v-else-if="userFieldUtils[field].type === 'textarea'"
                        filled
                        prepend-icon="mdi-focus-field-horizontal"
                        :label="userFieldUtils[field].text"
                        v-model="fields[key]"
                      ></v-textarea>
                    </div>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" v-if="this.state === 'edit'">
                <v-row>
                  <v-col>
                    <v-btn color="blue" dark @click="updateUser" :loading="updateRegisterLoading || fieldStatus">
                      <v-icon left size="20">mdi-refresh</v-icon>
                      {{ $t("PANEL.USER.DETAIL.UPDATE_USER_BTN") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" class="py-0">
                <v-row>
                  <v-col cols="12" lg="7" class="mt-3 pb-0" v-if="this.state === 'edit'">
                    <p class="text-overline mb-2">
                      <v-icon left>mdi-dialpad</v-icon>
                      {{ $t("PANEL.USER.DETAIL.UPDATE_PASSWORD_TITLE") }}
                    </p>
                    <v-divider></v-divider>
                  </v-col>
                  <v-col cols="12" lg="7">
                    <v-text-field
                      prepend-icon="mdi-key-variant"
                      :label="$t('PANEL.USER.DETAIL.UPDATE_PASSWORD_LABEL')"
                      :hint="$t('PANEL.USER.DETAIL.UPDATE_PASSWORD_HINT')"
                      persistent-hint
                      class="mt-0"
                      type="password"
                      v-model="userData.password"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="7">
                    <v-text-field
                      prepend-icon="mdi-key-variant"
                      :label="$t('PANEL.USER.DETAIL.UPDATE_PASSWORD_AGAIN_LABEL')"
                      :hint="$t('PANEL.USER.DETAIL.UPDATE_PASSWORD_AGAIN_HINT')"
                      persistent-hint
                      class="mt-0"
                      type="password"
                      v-model="userData.passwordAgain"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="this.state === 'edit'">
                <v-row>
                  <v-col>
                    <v-btn color="blue" dark @click="updatePassword" :loading="updateRegisterPassLoading">
                      <v-icon left size="20">mdi-refresh</v-icon>
                      {{ $t("PANEL.USER.DETAIL.UPDATE_PASSWORD_BTN") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>

              <!-- 25387169Ok -->

              <v-col v-if="state === 'new'">
                <v-btn color="green" dark @click="addNewUser()" :loading="updateRegisterLoading">
                  <v-icon left>mdi-account-plus</v-icon>
                  {{ $t("PANEL.USER.DETAIL.ADD_NEW_USER_BTN") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UserNavigation from "@/components/Settings/UserOperations/UserNavigation";

export default {
  props: {
    state: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      userData: {
        id: typeof this.$route.params.userID !== "undefined" ? this.$route.params.userID : "",
        name: "",
        nickname: "",
        email: "",
        password: "",
        passwordAgain: "",
        group: "",
        params: this.fields
      },
      userGroups: [],
      userFields: [],
      userFieldUtils: {
        avatar: {
          text: this.$t("PANEL.USER.FIELDS.AVATAR"),
          type: "file"
        },
        gsm: {
          text: this.$t("PANEL.USER.FIELDS.PHONE"),
          type: "text"
        },
        tel: {
          text: this.$t("PANEL.USER.FIELDS.TELEPHONE"),
          type: "text"
        },
        adress: {
          text: this.$t("PANEL.USER.FIELDS.ADDRESS"),
          type: "textarea"
        },
        ctsnumber: {
          text: this.$t("PANEL.USER.FIELDS.CITIZENSHIP_NUMBER"),
          type: "text"
        }
      },
      fields: [],
      fieldStatus: false,
      updateRegisterLoading: false,
      updateRegisterPassLoading: false
    };
  },
  components: {
    UserNavigation
  },
  methods: {
    /**
     *  Sisteme yeni kullanıcı ekle
     */
    addNewUser() {
      const { name, nickname, email, password, passwordAgain, group, params } = this.userData;
      this.updateRegisterLoading = true;
      this.$store
        .dispatch("User/UserList/newUser", {
          name,
          nickname,
          email,
          password,
          passwordAgain,
          group,
          params
        })
        .then(res => {
          if (res.status === 200) {
            Object.keys(this.userData).forEach(key => {
              if (key !== "params") this.userData[key] = "";
            });
            this.fields.forEach((field, key) => {
              this.fields[key] = "";
            });
            this.$snotify.success(this.$t("PANEL.USER.NOTIFY.USER_ADD_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.updateRegisterLoading = false;
        });
    },
    /**
     *  Herhangi bir kullanıcıyı düzenle
     */
    updateUser() {
      const { id, name, nickname, email, group, params } = this.userData;
      this.updateRegisterLoading = true;
      this.$store
        .dispatch("User/UserList/updateUser", {
          id,
          name,
          nickname,
          email,
          group,
          params
        })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("PANEL.USER.NOTIFY.USER_UPDATE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.updateRegisterLoading = false;
        });
    },
    updatePassword() {
      const { id, password, passwordAgain } = this.userData;
      this.updateRegisterPassLoading = true;
      this.$store
        .dispatch("User/UserList/updatePassword", {
          id,
          password,
          passwordAgain
        })
        .then(res => {
          if (res.status === 200) {
            this.userData.password = "";
            this.userData.passwordAgain = "";
            this.$snotify.success(this.$t("PANEL.USER.NOTIFY.USER_PASSWORD_UPDATE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.updateRegisterPassLoading = false;
        });
    },
    routerPath(num) {
      let path = this.$route.path.split("/");
      for (let i = 0; i < num; i++) {
        path.pop();
      }
      return path.join("/");
    }
  },
  created() {
    /**
     * Kullanıcı Gruplarını Getir
     */
    this.$store.dispatch("User/UserGroups/getUserGroups").then(data => {
      this.userGroups = data.data;
    });

    /**
     * Kullanıcı Alanlarını Getir
     */
    this.$store.dispatch("User/UserList/userFields").then(res => {
      this.userFields = res.data;
    });

    /**
     * Düzenleme ise verileri ekle
     */
    if (this.state === "edit") {
      this.fieldStatus = true;
      this.$store.dispatch("User/UserDetail/getUserDetail", Number(this.$route.params.userID)).then(res => {
        if (res.status !== 200) {
          let realPath = this.routerPath(2);
          this.$router.push(realPath);
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        } else {
          this.userData = { ...res.data };
          (this.userData.password = ""), (this.userData.passwordAgain = "");
          this.fieldStatus = false;
        }
      });
    }
  }
};
</script>
